'use client';

import { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import { InfoModal } from '@/components/ui/InfoModal/InfoModal';
import { LinkButton } from '@/components/ui/Button/Button';
import {
  ToneSharingPolicyChanges,
  ToneSharingPolicyLink,
} from '@/components/ui/ToneSharingPolicyModal/ToneSharingPolicyModal';
import {
  TONE_SHARING_POLICY_URL,
  dismissModerationAnnouncementModal,
  isModerationAnnouncementModalDismissed,
} from '@/utils/toneSharingPolicy';

const ModerationAnnouncementModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isModerationAnnouncementModalDismissed()) {
      setIsOpen(true);
    }
  }, []);

  const dismiss = () => {
    dismissModerationAnnouncementModal();
    setIsOpen(false);
  };

  return (
    <InfoModal
      open={isOpen}
      onClose={dismiss}
      icon={<Info size={24} className="text-white" />}
      title="New Tone Sharing Guidelines"
      className="h-[520px] max-h-[none]"
      message={
        <div className="flex flex-col gap-4 text-zinc-400">
          <ToneSharingPolicyChanges />
          <span>Action Required</span>
          <ul className="list-disc pl-6 flex flex-col gap-1">
            <li>
              Read the full <ToneSharingPolicyLink /> to see all of the changes.
            </li>
            <li>Update all public tone packs to comply with the new guidelines.</li>
          </ul>
          <span>Automated Moderation</span>
          <span>
            We&apos;re introducing automated moderation to check public tones for guideline
            violations. Tones that violate these guidelines will be flagged and made private.
            Repeated violations may result in account suspension.
          </span>
        </div>
      }
      action={
        <LinkButton href={TONE_SHARING_POLICY_URL} isPrimary className="w-full">
          Read the Guidelines
        </LinkButton>
      }
    />
  );
};

export default ModerationAnnouncementModal;
